import { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { createWorkCenterGroup, updateWorkCenterGroup } from "../api/workCenterGroups";

function WorkCenterGroupModal({ data, onClose, onSaved }) {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (data) {
      setCode(data.code || "");
      setName(data.name || "");
      setType(data.type || "");
    } else {
      setCode("");
      setName("");
      setType("");
    }
  }, [data]);

  async function save() {
    setError("");
    const c = String(code || "").trim();
    const n = String(name || "").trim();
    if (!c || !n) {
      setError("Kod ve ad zorunlu.");
      return;
    }

    const payload = { code: c, name: n, type: String(type || "").trim() || null };

    const req = data?.id ? updateWorkCenterGroup(data.id, payload) : createWorkCenterGroup(payload);
    setSaving(true);
    try {
      await req;
      await onSaved?.();
      onClose?.();
    } catch (err) {
      console.error("WORK CENTER GROUP SAVE ERROR", err);
      const status = err?.response?.status;
      const dataObj = err?.response?.data;
      const details = dataObj?.error?.details;
      const message =
        dataObj?.error?.message ||
        dataObj?.message ||
        (typeof dataObj === "string" ? dataObj : null) ||
        err?.message ||
        null;
      const detailsText =
        details && typeof details === "object"
          ? details.sqlMessage || details.key || details.db_code
          : typeof details === "string"
            ? details
            : null;
      setError(
        `Kaydedilemedi${status ? ` (HTTP ${status})` : ""}${message ? `: ${message}` : ""}${
          detailsText ? `\nDetay: ${detailsText}` : ""
        }`
      );
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {data ? "Makine Grubu Düzenle" : "Yeni Makine Grubu"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Makine grubu bilgilerini düzenleyin.
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <TextField label="Kod" value={code} onChange={(e) => setCode(e.target.value)} required disabled={saving} />
          <TextField label="Ad" value={name} onChange={(e) => setName(e.target.value)} required disabled={saving} />
          <TextField
            label="Tip (Baskı/Kesim)"
            value={type}
            onChange={(e) => setType(e.target.value)}
            disabled={saving}
            helperText="Opsiyonel"
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={saving}>
          İptal
        </Button>
        <Button onClick={save} variant="contained" disabled={saving}>
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WorkCenterGroupModal;
